/* eslint-disable no-unused-vars */
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Grid,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

import useI18N from "../../../hooks/useI18N";
import SAButton from "../../../shared/SAButton";
import SATruncateWithEllipsis from "../../../shared/SATruncateWithEllipsis";
import SATypography from "../../../shared/SATypography";

const SubscriptionMessageModal = ({
  subscriptionErrorMessage,
  isSuccesResponse,
  goToFinalStep,
  isErrorMessage,
  subscriptionModalOpen,
  onAfterPayment,
  session,
  successTitle,
  successSubtitle,
  errorTitle,
}) => {
  const { t } = useI18N();
  const theme = useTheme();

  const handleClose = () => {
    // keep behavior: reload to reflect subscription state
    if (isSuccesResponse) {
      onAfterPayment();
    } else if (isErrorMessage) {
      goToFinalStep();

      const params = new URLSearchParams(window.location.search);
      params.delete("payment_authentication");
      params.delete("tap_id");

      const newUrl =
        window.location.pathname +
        (params.toString() ? `?${params.toString()}` : "");

      // window.location.reload();
      // window.history.replaceState({}, "", newUrl);
      window.location.replace(newUrl);
    }
  };

  // removed unused date helpers
  const vatRate = session?.organization?.vat_rate || 0;
  const vatDecimal = vatRate > 1 ? vatRate / 100 : vatRate;
  const amount =
    session?.business_subscription?.subscription_plan?.discounted_fee ||
    session?.business_subscription?.subscription_plan?.subscription_fee ||
    0;
  const vatAmountNum = (Number(amount) || 0) * (vatDecimal || 0);
  const vatAmount = vatAmountNum.toFixed(2);
  const totalAmount = (Number(amount) || 0) + vatAmountNum;

  return (
    <Dialog
      open={subscriptionModalOpen}
      onClose={() => {}}
      disableEscapeKeyDown
      aria-labelledby="subscription-message-dialog"
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: { xs: 2, sm: 3 },
          mx: 2,
          bgcolor: theme.palette.background.paper,
          boxShadow: (t) => t.shadows[24],
          width: "100%",
          maxWidth: "500px",
        },
      }}
    >
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" p={1}>
          {isSuccesResponse && (
            <>
              <Box
                sx={{
                  width: { xs: 56, sm: 64 },
                  height: { xs: 56, sm: 64 },
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 1,
                  bgcolor: "transparent",
                  color: (t) => t.palette.success.main,
                }}
              >
                <CheckCircleOutlineIcon sx={{ fontSize: { xs: 36, sm: 44 } }} />
              </Box>

              <SATypography
                variant="h5"
                gutterBottom
                sx={{ fontWeight: 700, textAlign: "center" }}
              >
                {t(successTitle || "success-subscription-message")}
              </SATypography>

              {!successTitle && !successSubtitle && session?.email && (
                <SATypography
                  variant="body2"
                  color="text.secondary"
                  sx={{ textAlign: "center", maxWidth: 680, mb: 1 }}
                >
                  {t("sent-receipt-message")}{" "}
                  <Box component="span" sx={{ fontWeight: 700 }}>
                    <SATruncateWithEllipsis
                      text={session?.email}
                      maxLength={100}
                    />
                  </Box>{" "}
                  {t("confirm-subscription-message")}
                </SATypography>
              )}

              <SATypography
                variant="body2"
                color="text.secondary"
                sx={{ fontWeight: 600, mt: 1, textAlign: "center" }}
              >
                {t(successSubtitle || "subscription-success-subtitle")}
              </SATypography>

              {/* <Accordion sx={{ mt: 2, width: "100%" }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <SATypography sx={{ fontWeight: 700 }}>
                    {t("order-summary")}
                  </SATypography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={1}>
                    <Grid item xs={8}>
                      <SATypography>{t("amount")}</SATypography>
                    </Grid>
                    <Grid item xs={4}>
                      <SATypography align="right">
                        {Number(amount).toFixed(2)} BHD
                      </SATypography>
                    </Grid>

                    <Grid item xs={8}>
                      <SATypography>
                        {t("vat")} ({(vatDecimal * 100).toFixed(2)}%)
                      </SATypography>
                    </Grid>
                    <Grid item xs={4}>
                      <SATypography align="right">
                        {Number(vatAmount).toFixed(2)} BHD
                      </SATypography>
                    </Grid>

                    <Grid item xs={8}>
                      <SATypography fontWeight={700}>{t("total")}</SATypography>
                    </Grid>
                    <Grid item xs={4}>
                      <SATypography align="right" fontWeight={700}>
                        {Number(totalAmount).toFixed(2)} BHD
                      </SATypography>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion> */}
            </>
          )}

          {isErrorMessage && (
            <>
              <Box sx={{ mb: 1, color: (t) => t.palette.error.main }}>
                <ErrorOutlineIcon sx={{ fontSize: { xs: 36, sm: 44 } }} />
              </Box>

              <SATypography
                variant="h6"
                gutterBottom
                sx={{ fontWeight: 700, textAlign: "center" }}
              >
                {t(errorTitle || "error-message-title")}
              </SATypography>

              <SATypography
                variant="body2"
                color="text.secondary"
                sx={{ textAlign: "center", fontWeight: 500, fontSize: "14px" }}
              >
                {subscriptionErrorMessage
                  ? t(subscriptionErrorMessage)
                  : t("subscription-generic-error-message")}
              </SATypography>
            </>
          )}
        </Box>
      </DialogContent>

      <Divider />

      <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
        <SAButton
          variant="contained"
          onClick={handleClose}
          fullWidth
          sx={{
            borderRadius: 2,
            px: { xs: 2, sm: 4 },
            fontSize: { xs: "0.95rem", sm: "1rem" },
          }}
        >
          {t("ok")}
        </SAButton>
      </DialogActions>
    </Dialog>
  );
};

export default SubscriptionMessageModal;
